<template>
    <academic>
        <card-header :title="'Subject: '+subject.title+' - '+subject.code"/>
        <div class="p-6 bg-white border-b border-gray-200 shadow-sm sm:rounded-lg">
            <loading :showLoading="form.processing"/>
            <div :class="{'opacity-50':form.processing,'opacity-100':!form.processing}">
                <p class="text-lg font-medium mb-4">Edit Topic</p>
                <form @submit.prevent="submitForm">
                    <div class="grid grid-cols-8 gap-4 mb-4">
                        <div class="col-span-4 sm:col-span-4">
                            <breeze-label :required="true" :value="'Title'"/>
                            <breeze-input required v-model="form.title" class="w-full"/>
                            <breeze-input-error :message="form.errors?form.errors.title:''"/>
                        </div>
                        <div class="col-span-4 sm:col-span-4">
                            <breeze-label :required="true" :value="'Payout'"/>
                            <breeze-input type="number" step="0.01" v-model="form.payout" class="w-full"/>
                            <breeze-input-error :message="form.errors?form.errors.payout:''"/>
                        </div>
                        <div class="col-span-4 sm:col-span-4">

                            <FormMultiselect
                                label="Parent Topic"
                                :options="allTopics"
                                track-key="title"
                                label-key="title"
                                :object="true"
                                v-model="form.parent"
                                :placeholder="'Select parent topic'"
                                :error="form.errors.parent"
                            />
                        </div>
                        <div class="">
                            <breeze-label :value="'Theory'"/>
                            <breeze-checkbox type="checkbox" name="type" value="theory" v-model="form.is_theory"
                                             :checked="form.is_theory"/>
                            <breeze-input-error :message="form.errors?form.errors.is_theory:''"/>
                        </div>
                        <div class="">
                            <breeze-label :value="'Practical'"/>
                            <breeze-checkbox type="checkbox" name="type" value="practical" v-model="form.is_practical"
                                             :checked="form.is_practical"/>
                            <breeze-input-error :message="form.errors?form.errors.is_practical:''"/>
                        </div>
                        <div class="">
                            <breeze-label :value="'Subject'"/>
                            <breeze-checkbox type="checkbox" name="type" value="software" v-model="form.is_software"
                                             :checked="form.is_software"/>
                            <breeze-input-error :message="form.errors?form.errors.is_software:''"/>
                        </div>
                        <div class="">
                            <breeze-label :value="'Site Visit'"/>
                            <breeze-checkbox type="checkbox" name="type" value="sitevisit" v-model="form.is_site_visit"
                                             :checked="form.is_site_visit"/>
                            <breeze-input-error :message="form.errors?form.errors.is_site_visit:''"/>
                        </div>
                        <div class="">
                            <breeze-label :value="'Status'"/>
                            <breeze-checkbox v-model="form.status" :checked="form.status"/>
                            <breeze-input-error :message="form.errors?form.errors.status:''"/>
                        </div>

                    </div>
                    <button-link :href="route('academic.subject.topic.list',subject.id)"
                                 class="bg-red-500 mr-4 hover:bg-red-400">Cancel
                    </button-link>
                    <breeze-button :disabled="form.processing">Save</breeze-button>
                    <exception/>
                </form>
            </div>
        </div>
    </academic>
</template>

<script>
import Academic from '@/Pages/Academic/Academic'
import BreezeTable from '@/Components/Table'
import BreezeInput from '@/Components/Input'
import BreezeLabel from '@/Components/Label'
import BreezeButton from '@/Components/Button'
import BreezeCheckbox from '@/Components/Checkbox'
import InputCheckbox from '@/Components/InputCheckbox'
import BreezeInputError from '@/Components/InputError'
import ButtonLink from '@/Components/ButtonLink'
import Exception from '@/Components/Exception'
import CardHeader from '@/Components/CardHeader'
import SelectList from '@/Components/SelectList'
import {useForm} from '@inertiajs/inertia-vue3'
import Loading from '@/Components/Loading'
import FormMultiselect from "@/Components/Forms/FormMultiselect.vue";

export default {
    components: {
        FormMultiselect,
        Academic,
        BreezeTable,
        ButtonLink,
        BreezeInput,
        BreezeCheckbox,
        BreezeLabel,
        BreezeInputError,
        BreezeButton,
        Exception,
        InputCheckbox,
        CardHeader,
        SelectList,
        Loading
    },
    props: ['subject', 'topic', 'allTopics'],
    data() {
        return {
            form: useForm({
                '_method': 'PUT',
                title: this.topic.title,
                payout: this.topic.payout,
                is_theory: this.topic.is_theory,
                is_practical: this.topic.is_practical,
                is_software: this.topic.is_software,
                is_site_visit: this.topic.is_site_visit,
                parent: this.topic.parent,
                status: this.topic.status,
            })
        }
    },
    methods: {
        submitForm() {
            this.form.post(route('academic.subject.topic.update', [this.subject.id, this.topic.id]), {
                preserveScroll: true,
                onSuccess: () => this.form.reset(),
            });
        },
    },
}
</script>
